import React from 'react';
import { Col, Row } from "antd";
import { InputToolItem } from './InputToolItem';
import { tPropertyBar, tTable } from '../../../assets/libs/i18n/translator';

const RoundTableDefaultPropertiesPanel = ({
    roundTableSeats,
    roundTableSeatsHandler,
    roundTableRadius,
    roundTableRadiusHandler,
}) => {
    const items = [
        {
            label: tPropertyBar("seatsQuantity"),
            value: roundTableSeats,
            onChange: roundTableSeatsHandler,
        },
        {
            label: tTable("tableRadious"),
            value: roundTableRadius,
            onChange: roundTableRadiusHandler,
        },
    ];

    return (
        <Row>
            <Col span={24} className="mb-2">
                <h3>{tTable("roundTableConfig")}</h3>
            </Col>

            {items.map((item, index) => (
                <InputToolItem key={index} {...item} />
            ))}
        </Row>
    );
}

export { RoundTableDefaultPropertiesPanel };